define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/heading/_base",
	"csi/html",
	"csi/heading/RefImage",
	"csi/heading/RefImageBrowse",
	"csi/heading/RefImageRemove",
	"csi/heading/RefImageView",
	"csi/image/_base",
	"csi/reflection",
	"csi/xml",
	"dojo/text!csi/templates/imagesTooltip.html"
], function(array, declare, lang, _, csiHeading, html, RefImage, RefImageBrowse, RefImageRemove, RefImageView, csiImage, reflection, xml, tooltipTemplate) {

	return declare(RefImage, {
		bBaseRenderer: true,

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render image icon if any images
			if (actionData) {
				actionData.bTooltip = true;
			}

			if (csiImage.getDefaultImage(ctx.getNode())) {
				this._getViewAction(ctx).toHtmlWithAccess(ctx, refNode);
				return true;
			}

			return false;
		},

		toTooltip: function(/*Context*/ctx, /*Heading*/h, /*Tooltip*/tooltip) {
			// summary: generate tooltip for image
			// add cell action to tooltip if so specified
			this.type = xml.ATTR_REFMAP;
			var actionData = this._getRenderAction(ctx, h);

			// add image editing actions
			array.forEach(this._getTooltipActions(ctx, h, true), function(a) {
				tooltip.addAction(a);
			});

			// add expression action if appropriate
			tooltip.addAction(this._getExpressionAction(ctx, h, actionData));

			var node = ctx.getNode();
			var value = node[h.m_id];
			var keys = csiImage.getNumberedKeys(value);
			if (!keys.length) {
				return;
			}

			var removeAction = this._mixinTooltipAction(new RefImageRemove(), h);
			removeAction.classController = "csi.heading.RefImageSlideShowRemoveController";
			removeAction.hasOwnContext = function() {return true;};
			removeAction.setMaterialIcon("close");
			removeAction.resolve();
			tooltip.addAction(removeAction);

			var ctxImage = ctx.view.getContext();
			ctxImage.bReserveClick = true;
			ctxImage.prefImageSize = reflection.IMAGE_SIZE_SMALLEST;
			ctxImage.setReadOnly(true);

			var div = html.create("div");

			_.each(keys, function(key) {
				ctxImage.setNodeURL(value[key]);

				var domNode = html.templateToHtml(ctxImage, tooltipTemplate, this._tooltipDefs);

				// add action to remove image - use original context rather image context so we know
				// which node image is being removed from
				if (!xml.nodeIsFrozen(node)) {
					ctx.keyValue = key;
					csiHeading.setHeadingValueKey(removeAction.toHtml(ctx, domNode), key);
					ctx.keyValue = null;
				}

				div.appendChild(domNode);
			}, this);

			tooltip.addContent(div);
		},

		_getTooltipActions: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bBrowse) {
			// summary: return actions to browse and reset file
			var a = [];
			var path = xml.path(h.m_id);

			if (h.hasPathIndex()) {
				path = xml.path(path, xml.PATH_OP_INDEX, h.m_index);
			}

			if (ctx.bReserveClick) {
				// if selecting images, then use tooltip action to trigger lightbox
				a.push(this._mixinTooltipAction(new RefImageView(), h, true));
			}

			if (bBrowse) {
				a.push(this._mixinTooltipAction(lang.mixin(new RefImageBrowse(), {
					classController: "csi.heading.RefmapImageBrowseController"
				}), h));
			}

			return a;
		}
	});
});